import { render, staticRenderFns } from "./aiAppList.vue?vue&type=template&id=dcd813de&scoped=true"
import script from "./aiAppList.vue?vue&type=script&lang=js"
export * from "./aiAppList.vue?vue&type=script&lang=js"
import style0 from "./aiAppList.vue?vue&type=style&index=0&id=dcd813de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd813de",
  null
  
)

export default component.exports